export default __webpack_public_path__ + "static/media/krypto-logo-dark.e99bb4d8.png";